import { useState, useEffect } from 'react';
import { categories } from '@/mocks/categories';

const heroImage = 'https://readdy.ai/api/search-image?query=Soft%20artistic%20fashion%20editorial%20collage%20with%20modern%20sneakers%20hoodies%20and%20accessories%20on%20warm%20sand%20textured%20paper%20background%2C%20minimal%20creative%20style%2C%20neutral%20warm%20tones%2C%20gentle%20natural%20lighting%2C%20organic%20shadows%2C%20aesthetic%20magazine%20spread%2C%20clean%20sophisticated%20composition%2C%20subtle%20film%20grain%20texture%2C%20editorial%20fashion%20photography&width=1800&height=1000&seq=hero-bg-2026&orientation=landscape';

export default function HeroSection() {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    const handleClick = () => setDropdownOpen(false);
    if (dropdownOpen) {
      document.addEventListener('click', handleClick);
      return () => document.removeEventListener('click', handleClick);
    }
  }, [dropdownOpen]);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="Itaobuy Spreadsheet fashion editorial collage"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-background-50"></div>
      </div>

      {/* Background pattern overlay */}
      <div className="absolute inset-0 opacity-[0.03] bg-repeat" style={{
        backgroundImage: 'radial-gradient(circle, oklch(var(--foreground-950)) 1px, transparent 1px)',
        backgroundSize: '24px 24px',
      }}></div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center pt-20 pb-10">
        {/* Trust badges */}
        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mb-8">
          {['Aggiornamenti Frequenti', 'Guide in Italiano', 'Informazioni Organizzate', 'Consigli sulla Sicurezza'].map((badge) => (
            <span key={badge} className="inline-flex items-center gap-1.5 text-xs md:text-sm text-background-50/90 font-medium">
              <i className="ri-check-line text-accent-300 text-sm"></i>
              {badge}
            </span>
          ))}
        </div>

        {/* Main headline */}
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight mb-6 max-w-3xl mx-auto">
          Itaobuy Spreadsheet Italia
        </h1>

        <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          Trova i migliori prodotti con guide aggiornate e database organizzati. Scopri Itaobuy Spreadsheet aggiornati, categorie prodotti, consigli di qualità e guide complete per trovare rapidamente i migliori articoli online.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-4 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Itaobuy Sheet
            <i className="ri-arrow-right-up-line"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-4 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full text-base font-semibold hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <i className="ri-shopping-bag-line"></i>
          </a>
        </div>

        {/* Category Dropdown */}
        <div className="relative inline-block">
          <button
            onClick={(e) => { e.stopPropagation(); setDropdownOpen(!dropdownOpen); }}
            className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/90 backdrop-blur-sm text-foreground-800 rounded-full text-sm font-medium hover:bg-background-50 transition-colors whitespace-nowrap cursor-pointer shadow-sm"
          >
            <i className="ri-menu-search-line text-lg"></i>
            <span>Scegli una categoria</span>
            <i className={`ri-arrow-down-s-line transition-transform duration-200 ${dropdownOpen ? 'rotate-180' : ''}`}></i>
          </button>

          {dropdownOpen && (
            <div className="absolute top-full left-1/2 -translate-x-1/2 mt-3 w-72 bg-background-50 rounded-xl border border-background-200 shadow-lg py-2 max-h-80 overflow-y-auto z-50">
              {categories.map((cat) => (
                <a
                  key={cat.id}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="flex items-center justify-between px-5 py-3 text-sm text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
                >
                  <span>{cat.name}</span>
                  <i className="ri-arrow-right-up-line text-foreground-400 text-xs"></i>
                </a>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <a href="#categorie" className="flex flex-col items-center gap-2 text-background-50/60 hover:text-background-50 transition-colors">
          <span className="text-xs">Scopri di più</span>
          <i className="ri-arrow-down-line animate-bounce"></i>
        </a>
      </div>
    </section>
  );
}